<template>
  <SDropDown
    v-bind="dropdownAttrs"
    :id="`editDropdown-${item.id || item.uuid}`"
    no-caret
    class="add-dropdown"
    variant="transparent"
    data-cy="dropdown-list"
  >
    <template #button-content>
      <sdui-loader v-if="showSpinner" class="notification-spinner" />
      <span v-else class="reset-button btn d-flex align-items-center justify-content-around">
        <sdui-icon class="icon-more" variant="gray-300" />
        <span class="sr-only">{{ srOnlyDescr }}</span>
      </span>
    </template>
    <slot name="beforeItems" />
    <slot name="dropdownItems">
      <!-- Send notification -->
      <b-dropdown-item-button
        v-if="$can('notify-parents', item)"
        data-cy="send-notification"
        :disabled="showSpinner"
        @click.stop="$emit('sendAbsenceNotification')"
      >
        <sdui-icon class="icon-bell-o d-inline-block align-middle text-primary" />
        <span class="ml-2 d-inline-block align-middle">{{ $t('sick_notes.overview.notify_parents') }}</span>
      </b-dropdown-item-button>

      <!-- Edit item -->
      <b-dropdown-item-button v-if="$can('update', item) && showEditAction"
                              data-cy="edit"
                              @click.stop="$emit('edit')"
      >
        <sdui-icon class="icon-edit-o d-inline-block align-middle text-primary" />
        <span class="ml-2 d-inline-block align-middle">{{ $t('global.edit') }}</span>
      </b-dropdown-item-button>

      <li v-if="$can('update', item)"
          class="dropdown-divider"
          aria-hidden="true"
      />

      <!-- History for item -->
      <b-dropdown-item-button v-if="$can('view-history', item)"
                              data-cy="history"
                              @click.stop="$emit('history')"
      >
        <sdui-icon class="icon-clock-o d-inline-block align-middle text-primary" />
        <span class="ml-2 d-inline-block align-middle">{{ $t('global.history') }}</span>
      </b-dropdown-item-button>

      <li v-if="$can('view-history', item)"
          class="dropdown-divider"
          aria-hidden="true"
      />

      <!-- Delete item -->
      <b-dropdown-item-button v-if="$can('delete', item)"
                              data-cy="delete"
                              @click.stop="$emit('delete')"
      >
        <sdui-icon class="icon-delete-o d-inline-block align-middle text-primary" />
        <span class="ml-2 d-inline-block align-middle">{{ $t('global.delete') }}</span>
      </b-dropdown-item-button>
    </slot>
  </SDropDown>
</template>

<script>
import SduiLoader from 'src/components/miscellaneous/ui/common/SduiLoader.vue'
import isMobileDeviceMixin from 'src/mixins/miscellaneous/isMobileDeviceMixin.js'

export default {
  name: 'ClassbookListItemActions',
  components: { SduiLoader },
  mixins: [isMobileDeviceMixin],
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: true,
    },

    showEditAction: {
      type: Boolean,
      default: true,
    },

    showSpinner: {
      type: Boolean,
      default: false,
    },

    srOnlyDescr: {
      type: String,
      default: null,
      required: true,
    },
  },

  data: () => ({}),

  computed: {
    dropdownAttrs() {
      if (!this.isMobileLandscape) return
      return {
        'popper-opts': {
          placement: 'left-start',
          positionFixed: true,
          preventOverflow: { enabled: true },
        },
      }
    },
  },

  emits: ['sendAbsenceNotification', 'edit', 'history', 'delete'],

  methods: {},

  created() {},
}
</script>

<style scoped lang="scss">
.notification-spinner {
  width: 28px;
  height: 28px;
}
</style>
